/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
export function isHostComponent(element) {
  return typeof element === 'string';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/node_modules/@mui/base/utils/isHostComponent.js
// module id = 1426
// module chunks = 0